import React, { useState } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiSend, FiCheck } = FiIcons;

const Newsletter = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle, loading, success

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus('loading');
    // Simulate API call
    setTimeout(() => {
      setStatus('success');
      setEmail('');
    }, 1500);
  };

  return (
    <section className="py-24 bg-slate-900 relative overflow-hidden">
      {/* Background Decor */}
      <div className="absolute top-0 right-0 w-full h-full opacity-10 pointer-events-none">
        <div className="absolute top-[-20%] right-[-10%] w-[60%] h-[150%] bg-cyan-500 blur-[120px] rounded-full"></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="max-w-3xl">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6 leading-tight">
            Stay Optimized. <br />
            <span className="text-cyan-400">Join the Logic.</span>
          </h2>
          <p className="text-slate-400 text-lg mb-10 leading-relaxed">
            Get monthly insights on AI integration, enterprise architecture, and the future of intelligent systems. No spam, just engineering.
          </p>

          <form onSubmit={handleSubmit} className="relative max-w-md">
            {status === 'success' ? (
              <motion.div 
                key="success-msg"
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                className="flex items-center gap-3 text-cyan-400 font-bold uppercase tracking-[0.2em] text-xs py-4 px-6 border border-cyan-400/30 bg-cyan-400/5"
              >
                <SafeIcon icon={FiCheck} className="text-lg" />
                Welcome to the fold.
              </motion.div>
            ) : (
              <div className="flex flex-col sm:flex-row gap-3">
                <input
                  type="email"
                  required
                  placeholder="name@company.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="flex-1 bg-white/5 border border-white/10 px-6 py-4 text-white placeholder:text-slate-600 focus:outline-none focus:border-cyan-500 transition-colors uppercase tracking-widest text-[10px] font-black"
                />
                <button
                  disabled={status === 'loading'}
                  type="submit"
                  className="px-8 py-4 bg-white text-slate-900 font-black uppercase tracking-widest text-[10px] hover:bg-cyan-400 transition-all flex items-center justify-center gap-2 disabled:opacity-50"
                >
                  {status === 'loading' ? 'Sending...' : 'Subscribe'}
                  <SafeIcon icon={FiSend} />
                </button>
              </div>
            )}
          </form>
          <p className="mt-6 text-slate-500 text-[10px] uppercase tracking-widest font-black">
            Join 500+ Engineering Leaders
          </p>
        </div>
      </div>
    </section>
  );
};

export default Newsletter;
